var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('legal-doc-layout',{attrs:{"title-icon":_vm.titleIcon,"title":_vm._f("__")('privacy.title')}},[_c('v-md-preview',{attrs:{"text":_vm.privacyPolicy}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }